import { createContext, use } from 'react'

/**
 * Where the conversation is shown: the sidebar of canvas-main, or the page of
 * chat-main, where it is a centred column like any chat app.
 */
export type ChatVariant = 'sidebar' | 'main'

export const ChatVariantContext = createContext<ChatVariant>('sidebar')

export function useChatVariant(): ChatVariant {
  return use(ChatVariantContext)
}

/** Classes that keep a chat row inside the reading column of chat-main. */
export function useColumn(): string {
  return useChatVariant() === 'main' ? 'mx-auto w-full max-w-[760px]' : ''
}
